import FlashLib from "flashlib";
import MoneyFormat from "Base/MoneyFormat";

export default class BaseMobileWinContainer extends FlashLib.MovieClip {
    constructor(data, displayItemData) {
        super(data, displayItemData);

        this.valueText = null;

        this.init();
    }

    init() {
        this.valueText = this.getChildByName('valueText')
    }

    setValue(value) {
        this.valueText.text = MoneyFormat.format(value);
    }
}